import { SET_FINANCIAL_LIENS, SET_PROPERTY_FIELDS } from "../../types";
import { setAlert } from "../alert";

//  setFinanciaLiens gets called when the property component is loaded
//  It will responsible for setting up the FinanciaLiens object
//  and updating total to property fields

export const setFinancialLiens = () => async(dispatch, getState) => {
    try {
    //  Destructuring necessary items from redux store
        const { properties: { propertyFields } } = getState();
        const { financial_liens, financial_total_liens } = propertyFields;

        //  Reserved memory for FinanciaLiens
        let FinancialLiens = [];
        if (financial_liens) {
            FinancialLiens = JSON.parse(financial_liens);
        }

        //  Using reduce to caculate the total Liens
        const totalLiens = Object.values(FinancialLiens).reduce(
            (accumulate, value) => {
                const amount =
                    value.Released === "No" ? parseFloat(value.Amount) : 0;

                return accumulate + amount;
            },
            0
        );

        //  Setting FinanciaLiens object
        await dispatch({
            type: SET_FINANCIAL_LIENS,
            payload: FinancialLiens
        });

        //  If calculated total liens equal to current total liens
        //  Stop the execution

        if (parseInt(financial_total_liens) === totalLiens) {
            return;
        }

        //  Update total Liens if values are different
        const newPropertyFields = {
            ...propertyFields,
            financial_total_liens: totalLiens.toFixed(2)
        };
        dispatch({
            type: SET_PROPERTY_FIELDS,
            payload: newPropertyFields
        });
    }
    catch (error) {
        dispatch(
            setAlert(
                "Set Financial Liens Failed " + error.message,
                "error",
                2000
            )
        );
    }
};

//  updateFinancialLiens gets called when the Liens fields are updated
//  It will responsible for setting up the FinanciaLiens object
//  and updating total to property fields

export const updateFinancialLiens = event => async(dispatch, getState) => {
    // updatePropertyFields({ ...propertyFields, [event.target.name]: event.target.value });

    try {
        if (typeof event.target.value !== "string") {
            event.target.value = JSON.stringify(event.target.value);
        }
        //  Destructuring necessary items from redux store
        const { properties: { propertyFields } } = getState();

        //  Create temporary property fields object
        const tempPropertyFields = {
            ...propertyFields,
            [event.target.name]: event.target.value
        };
        const { financial_liens } = tempPropertyFields;

        //  Reserved memory for FinanciaLiens
        let FinancialLiens = [];
        if (financial_liens) {
            FinancialLiens = JSON.parse(financial_liens);
        }

        //  Using reduce to caculate the total Liens
        const totalLiens = Object.values(FinancialLiens).reduce(
            (accumulate, value) => {
                if (isNaN(parseFloat(value.Amount))) {
                    throw new TypeError("Please Enter the Value Amount");
                }

                //	Only add amount to Outstand Liens if Released is No.
                const amount =
                    value.Released === "No" ? parseFloat(value.Amount) : 0;
                return accumulate + amount;
            },
            0
        );

        //  Setting FinanciaLiens object
        await dispatch({
            type: SET_FINANCIAL_LIENS,
            payload: FinancialLiens
        });

        //  If calculated total liens equal to current total liens
        //  Stop the execution
        //	This causing other not saving
        //	Comment this out at this moment
        // if (financial_total_liens == totalLiens) {
        //     return;
        // }

        //  Update total Liens if values are different
        const newPropertyFields = {
            ...tempPropertyFields,
            financial_total_liens: totalLiens.toFixed(2)
        };
        dispatch({
            type: SET_PROPERTY_FIELDS,
            payload: newPropertyFields
        });
    }
    catch (error) {
        throw new TypeError(error.message);
    }
};